import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../services/customer.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RolePermission } from '../../shared/models/role.permission.enum';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  isMobile: boolean = false;

  constructor(private router: Router, private deviceDetectorService: DeviceDetectorService) {
    this.isMobile = !this.deviceDetectorService.isDesktop()
  }

  ngOnInit() {
    let canAdd = CustomerService.hasPermission(RolePermission.AddCustomer);
    if (!canAdd) {
      this.router.navigate(['/customer/']);
    }
  }
}
